import React, { useEffect, useState } from 'react'
import { Container, Table, Button, Modal, Form } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import axios from 'axios'
import toast from 'react-hot-toast'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const SeeTransaction = () => {
  const { booking_id } = useParams()
  console.log('Booking Id: ', booking_id)
  const [transactions, setTransactions] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [totalPaidAmount, setTotalPaidAmount] = useState(null)
  const [userType, setUserType] = useState('EMPLOYEE')
  const [showDateModal, setShowDateModal] = useState(false)
  const [editingTransaction, setEditingTransaction] = useState(null)
  const [newTransactionDate, setNewTransactionDate] = useState('')
  const [editPaymentMethod, setEditPaymentMethod] = useState('')
  const [editOnlineTransactionNumber, setEditOnlineTransactionNumber] = useState('')
  const [dateUpdateLoading, setDateUpdateLoading] = useState(false)

  const formatDateForInput = (dateString) => {
    if (!dateString) return ''
    return dateString.split(' ')[0]
  }

  // Check for authentication token on component mount
  useEffect(() => {
    const token = Cookies.get('authToken')
    if (!token) {
      window.location.href = '/login'
    }
    const role = Cookies.get('user_type')
    setUserType(role || 'EMPLOYEE')
  }, [])

  // Fetch transactions when booking_id changes
  useEffect(() => {
    if (booking_id) {
      fetchTransactions(booking_id)
    }
  }, [booking_id])

  const fetchTransactions = async (booking_id) => {
    const token = Cookies.get('authToken')
    try {
      const response = await axios.get(
        BASE_URL+`/booking/${booking_id}/transactions`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )

      console.log('API response:', response.data) // Log the response data

      // Check if the response contains a "data" field and it's an array
      if (response.status === 200 && Array.isArray(response.data.data)) {
        setTransactions(response.data.data)
        setTotalPaidAmount(response.data.total_paid_amount)
      } else {
        console.error('API did not return an array:', response.data)
        setTransactions([]) // Handle the case where "data" is not an array
      }
    } catch (error) {
      console.error('Error fetching transactions:', error)
      setTransactions([]) // Set to empty array if an error occurs
    } finally {
      setLoading(false) // Set loading to false once data is fetched
    }
  }

  // Format transaction date to a readable string
  const formatTransactionDateTime = (transactionDate) => {
    const date = new Date(transactionDate)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  const backHandler = () => {
    navigate('/allbooking')
  }

  const handleOpenDateModal = (transaction) => {
    setEditingTransaction(transaction)
    setNewTransactionDate(formatDateForInput(transaction.transaction_date))
    setEditPaymentMethod(transaction.payment_method || '')
    setEditOnlineTransactionNumber(transaction.online_transaction_number || '')
    setShowDateModal(true)
  }

  const handleCloseDateModal = () => {
    setShowDateModal(false)
    setEditingTransaction(null)
    setNewTransactionDate('')
    setEditPaymentMethod('')
    setEditOnlineTransactionNumber('')
  }

  const handleEditPaymentMethodChange = (e) => {
    const selectedMethod = e.target.value
    setEditPaymentMethod(selectedMethod)
    if (selectedMethod === 'CASH') {
      setEditOnlineTransactionNumber('')
    }
  }

  const handleUpdateTransactionDate = async (e) => {
    e.preventDefault()
    if (!editingTransaction || !newTransactionDate) {
      toast.error('Please select a transaction date')
      return
    }
    if (!editPaymentMethod) {
      toast.error('Please select a payment method')
      return
    }

    const payload = {
      transaction_date: newTransactionDate,
      payment_method: editPaymentMethod,
    }
    if (editPaymentMethod !== 'CASH') {
      payload.online_transaction_number = editOnlineTransactionNumber.trim() || null
    }

    const token = Cookies.get('authToken')
    setDateUpdateLoading(true)
    try {
      const response = await axios.put(
        `${BASE_URL}/update/transaction/date/${editingTransaction.id}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )

      if (response.status === 200) {
        toast.success(response.data.message || 'Transaction updated successfully')
        const updated = response.data.data
        setTransactions((prev) =>
          prev.map((txn) =>
            txn.id === editingTransaction.id
              ? {
                  ...txn,
                  transaction_date:
                    updated?.transaction_date ?? newTransactionDate,
                  payment_method: updated?.payment_method ?? editPaymentMethod,
                  online_transaction_number:
                    updated?.online_transaction_number ??
                    (editPaymentMethod === 'CASH' ? null : editOnlineTransactionNumber),
                }
              : txn,
          ),
        )
        handleCloseDateModal()
      }
    } catch (error) {
      const errors = error.response?.data?.errors
      const message =
        error.response?.data?.message ||
        errors?.transaction_date?.[0] ||
        errors?.payment_method?.[0] ||
        errors?.online_transaction_number?.[0] ||
        'Failed to update transaction'
      toast.error(message)
    } finally {
      setDateUpdateLoading(false)
    }
  }

  return (
    <Container className="pb-3" style={{fontFamily: theme.font.family }}>
        <div className="mb-4 ms-3 d-flex" style={{color: theme.colors.secondary , alignItems: 'center', cursor: 'pointer'}} onClick={backHandler}>
          
            <i class="fa-solid fa-arrow-left" ></i>

          
            <span className='px-2'>Back to all Booking</span>

        </div>
    
        <div className='mb-3 px-3 pb-3' style={{ backgroundColor: theme.colors.background }}>

        <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: '2px solid #ccc', paddingBottom: '8px' , fontSize: '1.5rem'}}>
            Transaction History for Booking{' - '}
            {transactions.length > 0 ? transactions[0].booking_id : ''}
        </p>
        


          <Table
            bordered
            hover
            responsive="md"
            className="text-center table table-striped table-bordered table-hover"
          >
            <thead className="text-start position-sticky top-0 ">
                <tr>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Transaction ID</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking ID</th>
                  {/* <th>Managed By</th> */}
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Payment Method</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Transaction Amount</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Online Transaction Number</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Date & Time</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Action</th>
                </tr>
                
            </thead>
            <tbody className="text-start">
              {loading ? (
                <tr>
                  <td colSpan={7} className="text-center">
                    Loading transactions...
                  </td>
                </tr>
              ) : !Array.isArray(transactions) || transactions.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center text-danger">
                    No transactions available
                  </td>
                </tr>
              ) : (
                transactions.map((transaction, index) => {
                  console.log(transaction) // Add this line to debug
                  const rowStyle =
                    index === 0
                      ? {
                          backgroundColor: '#FFF9C4',
                        }
                      : {}

                  return (
                    <tr key={transaction.id}>
                      <td style={rowStyle}>{transaction.id}</td>
                      <td style={{ cursor: 'pointer', ...rowStyle }}>
                        <Link
                          to={`/BookedDetailpage/${transaction.booking_id}`}
                        >
                          {transaction.booking_id}
                        </Link>
                      </td>
                      {/* <td>{transaction.transaction_managed_by ?? 'N/A'}</td> */}
                      <td style={rowStyle}>{transaction.payment_method}</td>
                      <td style={rowStyle}>{transaction.transaction_amount}</td>
                      <td style={rowStyle}>
                        {transaction.online_transaction_number ?? 'N/A'}
                      </td>
                      <td style={rowStyle}>
                        {formatTransactionDateTime(
                          transaction.transaction_date,
                        )}
                      </td>
                      <td>
                        <Button
                          variant="outline-primary"
                          className="btn-sm me-2"
                          title="Print Transaction Receipt"
                          onClick={() => {
                            navigate(`/seetransactionslip/${transaction.id}`)
                          }}
                        >
                          Print
                        </Button>
                        {userType === 'ADMIN' && (
                          <Button
                            variant="outline-success"
                            className="btn-sm"
                            title="Edit Transaction"
                            onClick={() => handleOpenDateModal(transaction)}
                          >
                            <i className="fa-solid fa-pen-to-square" />
                          </Button>
                        )}
                      </td>
                    </tr>
                  )
                })
              )}
            </tbody>
          </Table>
          <Container
            className="fw-bold"
            style={{ fontSize: '23px', color:theme.colors.secondary }}
          >
            Total amount received: ₹ {totalPaidAmount ?? 'N/A'}/-
          </Container>
       </div>
      <Modal show={showDateModal} onHide={handleCloseDateModal} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: theme.colors.primary }}>
            Edit Transaction
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleUpdateTransactionDate}>
          <Modal.Body>
            {editingTransaction && (
              <p className="text-muted mb-3">
                Transaction ID: <strong>{editingTransaction.id}</strong>
              </p>
            )}
            <Form.Group className="mb-3" controlId="transaction_date">
              <Form.Label>Transaction Date</Form.Label>
              <Form.Control
                type="date"
                value={newTransactionDate}
                onChange={(e) => setNewTransactionDate(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="payment_method">
              <Form.Label>Payment Method</Form.Label>
              <Form.Select
                value={editPaymentMethod}
                onChange={handleEditPaymentMethodChange}
                required
              >
                <option value="">SELECT</option>
                <option value="CASH">CASH</option>
                <option value="ONLINE">ONLINE</option>
                <option value="CHEQUE">CHEQUE</option>
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="online_transaction_number">
              <Form.Label>
                {editPaymentMethod === 'CASH'
                  ? 'Reference Number'
                  : editPaymentMethod === 'CHEQUE'
                  ? 'Cheque Number'
                  : 'Online Transaction Number'}
              </Form.Label>
              <Form.Control
                type="text"
                value={editOnlineTransactionNumber}
                onChange={(e) => setEditOnlineTransactionNumber(e.target.value)}
                placeholder={
                  editPaymentMethod === 'CASH'
                    ? 'N/A'
                    : editPaymentMethod === 'CHEQUE'
                    ? 'Enter Cheque Number'
                    : 'Enter Transaction Number'
                }
                disabled={editPaymentMethod === 'CASH'}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDateModal} disabled={dateUpdateLoading}>
              Cancel
            </Button>
            <Button
              type="submit"
              style={{ backgroundColor: theme.colors.primary, border: 'none' }}
              disabled={dateUpdateLoading}
            >
              {dateUpdateLoading ? 'Saving...' : 'Save'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  )
}

export default SeeTransaction
